module.exports = __webpack_public_path__ + "static/media/Cats eyes 03_SVENSKA-mixdown.63ef2ebe.mp3";